(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"));
	else if(typeof define === 'function' && define.amd)
		define("vue-tree-table-by-iview", ["vue"], factory);
	else if(typeof exports === 'object')
		exports["vue-tree-table-by-iview"] = factory(require("vue"));
	else
		root["vue-tree-table-by-iview"] = factory(root["Vue"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_23__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition